import { ArrowRight } from "lucide-react";
import Button from "shared/components/button/Button.jsx";
import PopularConferenceRoom from "./PopularConferenceRoom.jsx";
import { SPACES_ROUTE } from 'app/navigation/routes/space-routes';
import { useCallback } from "react";
import { useNavigationContext } from 'shared/providers/NavigationProvider';
import { useTranslation } from 'react-i18next';

const ReadyToStartSection = () => {
    return (
        <section className="py-5 lg:py-20 flex flex-col items-center">
            <ContentWrapper>
                <div className="block lg:hidden w-full">
                    <PopularConferenceRoom />
                </div>
                {/* Left side for large devices*/}
                <ReadyToStart />
                {/* Right side, visible only in large devices */}
                <div className="hidden lg:block lg:w-1/2">
                    <PopularConferenceRoom />
                </div>
            </ContentWrapper>
        </section>
    );
};

export default ReadyToStartSection;


const ContentWrapper = ({ children }) => {
    return (
        <div className="max-w-6xl w-full bg-white rounded-xl py-12 px-4 lg:px-12 flex flex-col lg:flex-row gap-12">
            {children}
        </div>
    );
};

const ReadyToStart = () => {

    const { t } = useTranslation();
    const { navigateToRoute } = useNavigationContext();

    const handleNavigateToSpacesPage = useCallback(
        () => navigateToRoute(SPACES_ROUTE),
        [navigateToRoute]
    );

    return (
        <div className="w-full lg:w-1/2 flex flex-col justify-center">
            <h2 className="text-4xl lg:text-5xl font-semi-bold text-gray-900 mb-6">
                {t('website.readyToStart.title')}
            </h2>

            <p className="text-gray-500 font-light text-lg max-w-[80%] leading-relaxed mb-8">
                {t('website.readyToStart.subtitle')}
            </p>

            <Button
                onClick={handleNavigateToSpacesPage}
                className="bg-lime-700 text-white px-6 py-2 rounded-md shadow hover:bg-lime-800 transition flex items-center text-lg w-fit"
            >
                <span className="flex items-center text-md">
                    {t('website.readyToStart.exploreSpaces')}
                    <ArrowRight className="ml-2 h-5 w-5" />
                </span>
            </Button>
        </div>
    );
};
